module.exports = require("./fur.js");